export enum MemberStatus {
  ACTIVE = 1,
  UNVERIFIED = 2,
  ARCHIVED = 3,
  INVITED = 4,
  DECLINED = 5,
  INACTIVE = 6,
}
